import { render } from "./SortBy.vue?vue&type=template&id=7840cfe4&scoped=true"
import script from "./SortBy.vue?vue&type=script&lang=js"
export * from "./SortBy.vue?vue&type=script&lang=js"

import "./SortBy.vue?vue&type=style&index=0&id=7840cfe4&scoped=true&lang=css"
import "./SortBy.vue?vue&type=style&index=1&id=7840cfe4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7840cfe4"]])

export default __exports__